// @ts-nocheck

/**
 * * `PENDING` - Pending
 * `GENERATING` - Generating
 * `COMPLETE` - Complete
 * `ERROR` - Error
 */
export type StatusAc6Enum = typeof StatusAc6Enum[keyof typeof StatusAc6Enum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StatusAc6Enum = {
  PENDING: "PENDING",
  GENERATING: "GENERATING",
  COMPLETE: "COMPLETE",
  ERROR: "ERROR",
} as const;
